import { render, staticRenderFns } from "./ProfileTableItemValueImage.vue?vue&type=template&id=50ef3197&scoped=true&"
import script from "./ProfileTableItemValueImage.vue?vue&type=script&lang=ts&"
export * from "./ProfileTableItemValueImage.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileTableItemValueImage.vue?vue&type=style&index=0&id=50ef3197&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef3197",
  null
  
)

export default component.exports